import type { VoidFunctionComponent } from 'react';

import { useReportLogoSettings } from '../../../../../../hooks/api/organization/useReportLogoSettings';
import LogoUpload from '../../../../../LogoUpload';
import SettingsPageHeader from '../../../../../shared/settings/SettingsPageHeader';
import SettingsPageSubheading from '../../../../../shared/settings/SettingsPageSubheading';

const ReleaseGroupsSettingsReports: VoidFunctionComponent = () => {
  const { fileUrl, setFile, unsetFile, handleImgError, onSave, isSaveDisabled, isLoading } = useReportLogoSettings();

  return (
    <>
      <SettingsPageHeader heading="Reports">
        <SettingsPageHeader.SaveButton onClick={onSave} isDisabled={isSaveDisabled} isLoading={isLoading} />
      </SettingsPageHeader>
      <SettingsPageSubheading>Report Logo</SettingsPageSubheading>
      <LogoUpload fileUrl={fileUrl} setFile={setFile} unsetFile={unsetFile} handleImgError={handleImgError} />
    </>
  );
};

export default ReleaseGroupsSettingsReports;
